if (window.location.pathname.includes('/cart')) {
    let loop = setInterval(() => {
     
      if(document.querySelectorAll('.bss-b2b-discount-code-wrapper').length) {
        clearInterval(loop);
        restyleRF();
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 15000)
}

function restyleRF() {
 let dc = document.querySelector('.bss-b2b-discount-code-wrapper')
  let cartNote = document.querySelector('.cart-note .form-control')
  cartNote.after(dc)
}

let checkExist = setInterval(function () {
    let element = document.querySelector(".quantity_break_table");

    if (element) {
        customQBTable();
        clearInterval(checkExist);
    }
}, 100);

setTimeout(function () {
    clearInterval(checkExist);
}, 8000);

function customQBTable() {
    let table = document.querySelector("table.quantity_break_table");
    if (table) {
        let headers = table.querySelector("thead tr");
        console.log()
        if (headers) {
            headers.innerHTML = headers.innerHTML + `<th class="bss-b2b-translation-qb-table_discount_text">  Prijs per stuk  </th>`
        }

        let rows = table.querySelectorAll("tbody tr");
        let productFormId = document.querySelector('[bss-b2b-product-form-id]') ? document.querySelector('[bss-b2b-product-form-id]') : ''
        if (productFormId) {
            let table = BSS_B2B.qb.utils.product.qbTables.get(productFormId.getAttribute('bss-b2b-product-form-id'))
            let product = BSS_B2B.storage.productFormStorage.get(productFormId.getAttribute('bss-b2b-product-form-id'))
            let applyQb
            console.log(product)
            if (product.appliedQB) {
                applyQb = product.appliedQB
            }
            let _tableTempData = table.get(applyQb.id)
            
            if (_tableTempData) {
                rows.forEach((row, index) => {
                 
                  let [firstKey, firstValue] = [..._tableTempData._tableTempData][index]
                  row.innerHTML = row.innerHTML + `<td> ${firstValue.priceValue} </td>`

                });
            }


        }


    } else {
        console.log("Table not found!");
    }
}